import { createFileRoute } from '@tanstack/react-router';

import { PageHeader } from '@/components/layout/PageHeader';
import { RequireCapability } from '@/components/layout/RequireCapability';
import { MetricsScreen } from '@/features/metrics/MetricsScreen';

/**
 * Metrics is its own screen, not part of the ops home.
 *
 * `/` answers "what needs me right now" and every role can see it. This answers "how are
 * we doing" — company revenue — and is read at a different time by a different person, so
 * it sits behind `metrics.view`, which only engineer and owner hold.
 */
export const Route = createFileRoute('/metrics')({
  component: Screen,
});

function Screen() {
  return (
    <RequireCapability capability="metrics.view">
      <div className="flex flex-col gap-4">
        <PageHeader
          eyebrow="Growth"
          title="Metrics"
          meta="Revenue, purchasers and engagement, straight from the ledger. Gross figures — pull a real report before anyone quotes one."
        />
        <MetricsScreen />
      </div>
    </RequireCapability>
  );
}
